import React from 'react';
import { Text, TagFeedback, Button } from '@spark';
import { DateTimeWithTimeTooltip } from '@/shared/utils/helpers';
/**
 * Displays the run date for the currently viewed evaluation alongside an inline
 * "Switch to latest" link when the user is viewing a historical (non-latest) run.
 */
function formatVersionLabel(version) {
    if (version == null) return null;
    const n = Number(version);
    if (!Number.isFinite(n)) return null;
    const text = n.toFixed(0) === String(n) ? `${n}.0` : String(n);
    return `V${text}`;
}

const EvaluationRunStatus = ({
    runDateIso,
    isLatest,
    version,
    style,
    onSwitchToLatest,
}) => {
    if (!runDateIso) return null;

    const versionLabel = formatVersionLabel(version);

    return (
        <div
            className="fs-unmask"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flexWrap: 'wrap',
                ...(style || {}),
            }}
        >
            <Text variant="base-regular" color="secondary">Ran at:</Text>
            <Text variant="base-medium" color="primary">
                <DateTimeWithTimeTooltip value={runDateIso} emptyPlaceholder="—" />
                {versionLabel && (
                    <Text variant="base-regular" color="secondary" as="span" style={{ marginLeft: 4 }}>
                        ({versionLabel})
                    </Text>
                )}
            </Text>
            {isLatest === true && (
                <TagFeedback label="Latest" variant="success" showIcon />
            )}
            {isLatest === false && typeof onSwitchToLatest === 'function' && (
                <Button
                    variant="ghost"
                    size="small"
                    onClick={onSwitchToLatest}
                >
                    Switch to latest
                </Button>
            )}
        </div>
    );
};

export default EvaluationRunStatus;
